import { render, staticRenderFns } from "./addsystemRoleaaa.vue?vue&type=template&id=c06eeece&scoped=true&"
import script from "./addsystemRoleaaa.vue?vue&type=script&lang=js&"
export * from "./addsystemRoleaaa.vue?vue&type=script&lang=js&"
import style0 from "./addsystemRoleaaa.vue?vue&type=style&index=0&id=c06eeece&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c06eeece",
  null
  
)

export default component.exports